import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getLabCatalog, getLabStations } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabFilterBar from '../components/LabFilterBar';
import LabRiskBadge from '../components/LabRiskBadge';
import LabTable from '../components/LabTable';
import { useSmartiLabContext } from '../SmartiLabContext';

export default function StationHealthPage() {
  const { sharedQuery } = useSmartiLabContext();
  const [catalog, setCatalog] = useState(null);
  const [ateVersion, setAteVersion] = useState('');
  const [rows, setRows] = useState([]);

  useEffect(() => {
    getLabCatalog(sharedQuery).then(setCatalog).catch(() => {});
  }, [sharedQuery]);

  useEffect(() => {
    getLabStations({ ...sharedQuery, ...(ateVersion ? { ateVersion } : {}) }).then((data) => setRows(data.rows || []));
  }, [ateVersion, sharedQuery]);

  return (
    <div className="lab-page">
      <LabCard title="Salute stazioni" description="Scoring di salute a livello stazione con fail-rate, step più critico e attività recente.">
        <LabFilterBar>
          <select className="lab-input" value={ateVersion} onChange={(event) => setAteVersion(event.target.value)}>
            <option value="">Tutte le versioni ATE</option>
            {(catalog?.production?.ateVersions || []).map((value) => <option key={value} value={value}>{value}</option>)}
          </select>
        </LabFilterBar>
        <LabTable
          rows={rows}
          emptyTitle="Nessun upload di produzione trovato."
          emptyDescription="La salute stazioni ha bisogno di storico test di produzione prima di poter calcolare uno score."
          columns={[
            { key: 'stationName', label: 'Stazione', render: (value) => <Link to={`/smarti-lab/stations/${encodeURIComponent(value)}`}>{value}</Link> },
            { key: 'healthLabel', label: 'Salute', render: (value) => <LabRiskBadge label={value} /> },
            { key: 'failRate', label: 'Fail rate %' },
            { key: 'totalTests', label: 'Test' },
            { key: 'uniqueSerials', label: 'Seriali' },
            { key: 'topFailingStep', label: 'Step più critico' },
            { key: 'healthExplanation', label: 'Perché', render: (value) => (value || []).join(' · ') || '—' },
            { key: 'latestTestStarted', label: 'Ultimo test' },
          ]}
        />
      </LabCard>
    </div>
  );
}
